module.exports = __webpack_public_path__ + "assets/img/budapark6-1920.6ff426c0.webp";